<template>
	<div class="title-page">
		<h1 class="title">Partager un CIL</h1>
	</div>
	<div class="partage-ctn">
		<div class="card white">
			<h2>Détails du logement</h2>
			<div class="form-group">
				<div class="form-control">
					<label for="name">Nom du partage*</label>
					<input type="text" id="name" v-model="name" required />
				</div>
			</div>

			<div class="form-group">
				<div class="form-control type">
					<label for="expiration">Date d'expiration</label>
					<input type="date" id="expiration" name="expiration" v-model="expiration" />
				</div>

				<div class="form-control">
					<label for="password">Mot de passe</label>
					<input type="password" id="password" v-model="password" />
				</div>
			</div>

			<div v-if="errorMessage" class="message">{{ errorMessage }}</div>
		</div>
		<div>
			<div class="card white">
				<h2>Fichiers du logement</h2>
				<template v-for="(category, categoryName) in filteredFiles" :key="categoryName">
					<div v-for="item in category" :key="item.ID" class="sahre-file-ctn">
						<h5 class="title-file">{{ item.name }}</h5>
						<div v-if="item.files.length > 0">
							<div v-for="file in item.files" :key="file.ID" class="file-entry">
								<input type="checkbox" :id="file.ID" :value="file.ID" v-model="selectedFiles" />
								<label :for="file.ID">{{ file.name }}</label>
							</div>
						</div>
					</div>
				</template>
				<div v-if="Object.keys(filteredFiles).length == 0" style="text-align: center; padding: 50px 0">
					<h2>Aucun fichiers trouvés</h2>
					<img src="https://www.mondomicil.fr/wp-content/uploads/2024/05/Fichier-9.png"
						alt="Aucun équipement trouvé" />
				</div>
			</div>
			<br>
			<button v-if="Object.keys(filteredFiles).length !== 0" @click="submitForm"
				class="button fill normal">Ajouter</button>
			<button v-else @click="goHome" class="button fill normal">Ajouter des fichiers</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "MesLogements",
	props: ["currentProperty", "user"],
	data() {
		return {
			name: "",
			expiration: "",
			password: "",
			allFiles: {},
			selectedFiles: [],
			errorMessage: "",
		};
	},
	mounted() {
		if (this.currentProperty && Object.keys(this.currentProperty).length > 0) {
			this.fetchAllFiles();
		}
		this.$watch("currentProperty", () => {
			if (this.currentProperty && Object.keys(this.currentProperty).length > 0) {
				this.fetchAllFiles();
			}
		});
	},
	watch: {
		selectedFiles(newFiles) {
			console.log("Selected files:", newFiles);
		},
	},
	methods: {
		async fetchAllFiles() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "partages/fichiers/p/" + this.currentProperty.ID, { method: "GET", credentials: "include", });
				const data = await response.json();

				if (data.error) return window.location.href = "/login";

				this.allFiles = data;
			} catch (error) {
				console.error("Une erreur est survenue lors de la requête.");
			}
		},
		async submitForm() {
			if (!this.name) return this.errorMessage = "Veuillez choisir un nom.";
			if (!this.selectedFiles.length) return this.errorMessage = "Veuillez choisir des fichiers.";

			try {
				const body = JSON.stringify({
					propID: this.currentProperty.ID,
					name: this.name,
					selectedFiles: this.selectedFiles,
					expiration: this.expiration || null,
					password: this.password || null,
				});
				const response = await fetch(process.env.VUE_APP_API_URL + "partages/add", { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body, });

				if (!response.ok) return this.errorMessage = "Erreur lors de la soumission des données. Veuillez réessayer.";

				this.errorMessage = "";
				this.$router.push(`/mes-partages`);
			} catch (error) {
				console.error("Erreur lors de la soumission du formulaire:", error);
				this.errorMessage = "Erreur lors de l'envoi des données. Veuillez réessayer.";
			}
		},
		goHome() {
			this.$router.push(`/`);
		}
	},
	computed: {
		filteredFiles() {
			const filteredCategories = Object.entries(this.allFiles).reduce((acc, [category, files]) => {
				const nonEmptyFiles = files.filter((file) => file.files.length > 0);
				if (nonEmptyFiles.length > 0) {
					acc[category] = nonEmptyFiles;
				}
				return acc;
			}, {});
			return filteredCategories;
		},
	},
};
</script>

<style scoped>
.form-control.type {
	flex: 0.5;
}

.partage-ctn {
	display: flex;
	gap: 20px;
}

.partage-ctn>div:first-child {
	flex: 0 0 calc(60% - 10px);
	box-sizing: border-box;
	height: fit-content;
}

.partage-ctn>div:last-child {
	flex: 0 0 calc(40% - 10px);
	box-sizing: border-box;
	height: fit-content;
}

.sahre-file-ctn {
	margin-top: 15px;
}

.title-file {
	margin: 5px 4px;
}

@media (max-width: 1200px) {
	.partage-ctn {
		flex-direction: column !important;
	}
}
</style>
